import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import OfficeCubicleQuotesWrapper from "@components/layouts/officecubiclequotesWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <OfficeCubicleQuotesWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#df5065" />
                </div>
                <FormSection iconsFillColor="#df5065" />
            </div>
        </OfficeCubicleQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
